<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">List Post Schedule</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">List Post Schedule</li>
                </ul>
              </div>
              <div class="col-auto float-right ms-auto">
                <router-link
                  :to="'/instagram-official/post/wizard'"
                  :class="'btn add-btn'"
                >
                  <i class="la la-image"></i> Post
                </router-link>
                <div class="view-icons">
                  <a
                    @click.prevent="onDisplayList('list')"
                    href="javascript:void(0)"
                    :class="`btn btn-link me-2 ${displayList && 'active'}`"
                  >
                    <VueCustomTooltip label="Card" position="is-bottom"
                      ><i class="fa fa-th"></i
                    ></VueCustomTooltip>
                  </a>
                  <a
                    @click.prevent="onDisplayList('calendar')"
                    href="javascript:void(0)"
                    :class="
                      `btn btn-link ${displayCalendarFirst == false &&
                        displayCalendar &&
                        'active'}`
                    "
                  >
                    <VueCustomTooltip label="Calendar" position="is-bottom"
                      ><i class="fa fa-bars"></i
                    ></VueCustomTooltip>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <!-- {{formParamSt}} -->
          <!-- /Page Header -->
          <!-- {{serverParams}} -->
          <!-- Search Filter -->
          <!-- {{selectAllTable}}-->
          <!-- {{selectedTable}} -->
          <div class="row filter-row" v-if="!selectedTable.length">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <!-- <div class="cal-icon"> -->
                <input
                  v-model="serverParams.columnFilters.start_date"
                  class="form-control floating"
                  type="date"
                />
                <!-- </div> -->
                <label class="focus-label sr-only">From</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <div class="input-group">
                  <!-- <div class="cal-icon"> -->
                  <input
                    v-model="serverParams.columnFilters.end_date"
                    class="form-control floating"
                    type="date"
                  />
                  <!-- </div> -->
                  <div class="input-group-append">
                    <a
                      title="Show search options"
                      class="btn btn-primary"
                      @click="showSearchForm()"
                      href="#"
                      data-toggle="modal"
                      data-target="#search_form"
                    >
                      <i class="fa fa-list"></i>
                      <i
                        class="fa fa-circle"
                        v-if="formParamSt.more_search == true"
                      ></i>
                    </a>
                  </div>
                </div>

                <label class="focus-label sr-only">To</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <a
                  href="javascript:void(0)"
                  @click.prevent="searchData"
                  class="btn btn-success btn-block"
                  >Search</a
                >
              </div>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionUpdateStatus('unpublish')"
                  class="btn btn-primary btn-block"
                >
                  <i class="la la-pause"></i> Unpublish
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionUpdateStatus('publish')"
                  class="btn btn-success btn-block"
                >
                  <i class="la la-check"></i> Publish
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionDelete"
                  class="btn btn-danger btn-block"
                >
                  <i class="la la-trash"></i> Delete
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>

          <div v-show="displayList" class="row">
            <div class="col-md-3">
              <label for="selectAll" class="box-check-all">
                <div style="margin-right: 10px">
                  <input
                    id="selectAll"
                    type="checkbox"
                    v-model="selectAllTable"
                  />
                </div>
                <div>Select All</div>
              </label>
            </div>
          </div>

          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <div v-show="displayList" class="row align-items-start">
                <template v-if="loading">
                  <div class="col-md-12">
                    <skeleton :count="1" />
                  </div>
                </template>
                <template v-if="rows.length">
                  <div
                    v-for="(row, index) in rows"
                    :key="index"
                    class="col-md-6 col-xl-4 pb-4"
                  >
                    <div class="of-card">
                      <div class="of-card-top"></div>
                      <div class="of-card-header">
                        <div class="of-card-h-1">
                          <div class="of-card-h-2">
                            <div class="of-card-h-6">
                              <div style="margin-right: 10px">
                                <div class="checkbox">
                                  <label>
                                    <!-- <input type="checkbox" name="checkbox" /> -->
                                    <input
                                      type="checkbox"
                                      v-model="selectedTable"
                                      :value="row.id"
                                    />
                                  </label>
                                </div>
                              </div>
                              <div>
                                <div class="of-card-h-7">
                                  {{ formatLocalDate(row.update_datetime) }}
                                </div>
                                <ul class="tm" :ref="'account-' + row.id">
                                  <Skeleton :count="1" />
                                </ul>
                              </div>
                            </div>
                            <div class="text-end">
                              <div class="dropdown dropdown-action">
                                <a
                                  href="javascript:void(0)"
                                  class="action-icon dropdown-toggle"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i class="material-icons">more_vert</i>
                                  <span class="sr-only">Toggle Dropdown</span>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right">
                                  <router-link
                                    :to="'wizard?id=' + row.id"
                                    class="dropdown-item"
                                    :disabled="
                                      row.is_publish == 0 ||
                                      (row.sending_options == 2 &&
                                        row.sending_schedule >
                                          currentDateTimeUnix())
                                        ? false
                                        : true
                                    "
                                  >
                                    <i class="fa fa-pencil m-r-5"></i> Edit
                                  </router-link>
                                  <router-link
                                    :to="'wizard?id=' + row.id + '&copy=1'"
                                    class="dropdown-item"
                                  >
                                    <i class="fa fa-copy m-r-5"></i> Copy
                                  </router-link>
                                  <a
                                    href="javascript:void(0)"
                                    class="dropdown-item"
                                    @click.prevent="
                                      showSearchFormSummary(row.id)
                                    "
                                    data-toggle="modal"
                                    data-target="#summary_form"
                                    :disabled="
                                      row.is_publish == 0 ||
                                        (row.sending_options == 2 &&
                                          row.sending_schedule >
                                            currentDateTimeUnix())
                                    "
                                  >
                                    <i class="la la-eye m-r-5"></i> Statistik
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="of-card-body">
                        <div class="of-card-body-a">
                          <div class="of-card-body-cap">
                            <div class="of-card-body-cap-1">
                              <p
                                :title="row.caption"
                                class="of-card-body-cap-2"
                              >
                                {{ row.caption }}
                              </p>
                            </div>
                          </div>
                          <div class="of-card-body-img">
                            <template
                              v-if="JSON.parse(row.assets_url).length > 0"
                            >
                              <img
                                v-if="
                                  JSON.parse(row.assets_url)[0].includes(
                                    '.jpg'
                                  ) ||
                                    JSON.parse(row.assets_url)[0].includes(
                                      '.jpeg'
                                    )
                                "
                                title="Lihat Gambar"
                                @click="
                                  openImage(JSON.parse(row.assets_url)[0])
                                "
                                style="cursor: zoom-in"
                                class="of-card-body-img-p"
                                :src="JSON.parse(row.assets_url)[0]"
                                :alt="row.caption"
                              />
                              <video
                                style="
                                  width: 100%;
                                  height: 100%;
                                  overflow: hidden;
                                "
                                v-else-if="
                                  JSON.parse(row.assets_url)[0].includes('.mp4')
                                "
                                controls
                              >
                                <source
                                  :src="JSON.parse(row.assets_url)[0]"
                                  type="video/mp4"
                                />
                              </video>
                              <img
                                v-else
                                class="of-card-body-img-p"
                                :src="require('@/assets/placeholder.jpg')"
                                alt=""
                              />
                            </template>
                            <template v-else>
                              <img
                                class="of-card-body-img-p"
                                :src="require('@/assets/placeholder.jpg')"
                                alt=""
                              />
                            </template>
                          </div>
                        </div>
                        <div class="of-card-body-b"></div>
                        <div class="of-card-body-c">
                          <table class="of-card-table">
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Brand</td>
                                <td class="of-card-td-r">
                                  <div
                                    style="width: 150px"
                                    :ref="'brand-' + row.id"
                                  >
                                    <Skeleton :count="1" />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Media Type</td>
                                <td class="of-card-td-r">
                                  <span class="badge badge-primary">{{
                                    row.media_type
                                  }}</span>
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr>
                                <td class="of-card-td-l">Reccuring</td>
                                <td
                                  class="of-card-td-r"
                                  style="line-height: 19.5px"
                                >
                                  <template v-if="row.is_recurring == 1">
                                    <i class="fa fa-clock-o"></i>
                                    {{ row.recurrence }}
                                    <span>
                                      <br />
                                      time:
                                      {{
                                        formatHourFromUnix(
                                          convertUTCDatetimeToUnix(
                                            row.recurrence_time
                                          )
                                        )
                                      }}
                                    </span>
                                    <span v-if="row.recurrence != 'daily'">
                                      <br />
                                      every: {{ row.recurrence_every }}
                                      {{ row.recurrence_annually_month }}
                                    </span>

                                    <br />end:
                                    <span
                                      v-if="row.recurrence_end == 'never'"
                                      >{{ row.recurrence_end }}</span
                                    >
                                    <span v-else>{{
                                      formatLocalDate(row.recurrence_end_date)
                                    }}</span>
                                  </template>
                                  <template v-else>-</template>
                                </td>
                              </tr>
                            </tbody>
                            <tbody>
                              <tr style="border: none">
                                <td class="of-card-td-l">Status</td>
                                <td
                                  class="of-card-td-r"
                                  style="line-height: 19.5px"
                                >
                                  <template v-if="row.is_publish == 0">
                                    <span :class="'text text-warning'">
                                      <i class="fa fa-pause"></i>
                                      DRAFT
                                    </span>
                                  </template>
                                  <template v-if="row.is_publish == 1">
                                    <span
                                      :class="'text text-success'"
                                      v-if="row.sending_options == 1"
                                    >
                                      <i class="fa fa-check"></i>
                                      SENT
                                      <br />
                                      <small v-if="row.cron_timestamp > 0">{{
                                        timeAgo(row.cron_timestamp)
                                      }}</small>
                                      <small v-else>
                                        {{ timeAgo(row.update_datetime) }}
                                        <br />(send now)
                                      </small>
                                    </span>
                                    <span
                                      :class="'text text-success'"
                                      v-if="
                                        row.sending_options == 2 &&
                                          row.sending_schedule <
                                            currentDateTimeUnix()
                                      "
                                    >
                                      <i class="fa fa-check"></i>
                                      Sent
                                      <br />
                                      <small v-if="row.cron_timestamp > 0">{{
                                        timeAgo(row.cron_timestamp)
                                      }}</small>
                                    </span>
                                    <span
                                      :class="'text text-info'"
                                      v-if="
                                        row.sending_options == 2 &&
                                          row.sending_schedule >
                                            currentDateTimeUnix()
                                      "
                                    >
                                      <i class="fa fa-clock-o"></i>
                                      Scheduled
                                      <br />
                                      <small>{{
                                        formatLocalDateWithDay(
                                          row.sending_schedule
                                        )
                                      }}</small>
                                    </span>
                                  </template>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="rows.length < 1 && !loading">
                  <div class="col-md-12 text-center">-empty-</div>
                </template>
              </div>
              <div
                v-show="displayCalendar"
                class="row"
                :style="
                  `margin-bottom: 20px; margin-top: 10px; ${
                    displayCalendarFirst && displayList
                      ? 'visibility: hidden;'
                      : 'visibility: visible;'
                  }`
                "
              >
                <div class="col-md-12">
                  <FullCalendar ref="fullCalendar" :options="calendarOptions">
                    <template v-slot:eventContent="arg">
                      <a
                        href="javascript:void(0)"
                        class="event-slot-c"
                        data-toggle="modal"
                        data-target="#detail_form"
                        :title="arg.event.title"
                      >
                        <div class="fc-daygrid-event-dot"></div>
                        <div class="fc-event-time">{{ arg.timeText }}</div>
                        <div class="fc-event-title">{{ arg.event.title }}</div>
                      </a>
                    </template>
                  </FullCalendar>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label"
                >of {{ totalRecords }} total records</span
              >
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width: 100px"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="
                  'btn ' +
                    {
                      disabled:
                        parseInt(currentPage) + 1 >
                        Math.ceil(totalRecords / serverParams.perPage)
                    }
                "
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data :searchData="searchDataMore" />

    <form-detail :searchData="searchData" />

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Skeleton } from "vue-loading-skeleton";
import {
  getFirstLastDayInWeek,
  formatDateForMessage,
  formatPrice,
  formatLocalDate,
  marketplaceIcon,
  monitoringStatusLabelStyle,
  monitoringStatusLabel,
  timeAgo,
  marketplaceLabelFilter,
  formatLocalDateWithDay,
  formatHourFromUnix,
  convertUTCDatetimeToUnix,
  currentDateTimeUnix
} from "@/utils/helper";
import FormData from "./form.vue";

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { Carousel, Slide } from "vue-carousel";
// import FormSummary from "./summary.vue";
import FormDetail from "./detail.vue";

import VueCustomTooltip from "@adamdehaven/vue-custom-tooltip";
import Vue from "vue";

import "@fullcalendar/core"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData,
    Carousel,
    Slide,
    FormDetail,
    VueCustomTooltip,
    FullCalendar
  },
  data() {
    return {
      linkExcel: "",
      displayList: true,
      displayCalendar: true,
      displayCalendarFirst: true,
      selectedTable: [],
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          start_date: "",
          end_date: "",
          instagram_account_id: "",
          brand_id: "",
          media_type: "",
          is_publish: "",
          is_running: "",
          is_official: "1"
        },
        page: 1,
        perPage: 20, // perPage
        more_search: false
      }
    };
    //  isactive : true
  },
  computed: {
    ...mapGetters(["events_calendar"]),
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        dateClick: this.handleDateClick,
        eventClick: this.handleEventClick,
        events: this.events_calendar,
        height: 650,
        headerToolbar: {
          left: "prev,next",
          center: "title",
          right: "today"
        }
      };
    },
    formParamSt() {
      return this.$store.state.instagramSchedule.formParamStB;
    },
    isShowForm() {
      return this.$store.state.instagramSchedule.isShowForm;
    },
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function(row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {},
  created() {
    this.getFirstLastDayInWeek();
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    onDisplayList(arg) {
      if (arg == "list") {
        this.displayList = true;
        this.displayCalendarFirst = false;
        this.displayCalendar = false;
      } else if (arg == "calendar") {
        this.displayCalendarFirst = false;
        this.displayCalendar = true;
        this.displayList = false;
      }
    },
    handleDateClick: function(arg) {
      return true;
    },
    handleEventClick(payload) {
      this.$store.dispatch("instagramSchedule/setIsShowFormSummary", false);
      this.$store.dispatch(
        "instagramSchedule/setIsShowFormSummaryId",
        payload.event.extendedProps.event_permalink
      );
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("detail_form");
        var isShowModal = liContainer.classList.contains("show");
        if (isShowModal == true) {
          that.$store.dispatch("instagramSchedule/setIsShowFormSummary", true);
        }
      }, 1000);
    },
    openImage(url) {
      window.open(url, "_blank");
    },
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },
    marketplaceLabelFilter(sortBy, orderBy) {
      return marketplaceLabelFilter(sortBy, orderBy);
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },
    showSearchFormSummary(id) {
      this.$router.push(
        `/instagram-official/post/statistik?instagram_schedule_id=${id}`
      );
      // this.$store.dispatch("instagramSchedule/setIsShowFormSummary", false);
      // this.$store.dispatch("instagramSchedule/setIsShowFormSummaryId", id);
      // var that = this;
      // setTimeout(function() {
      //   var liContainer = document.getElementById("summary_form");
      //   var isShowModal = liContainer.classList.contains("show");
      //   if (isShowModal == true) {
      //     that.$store.dispatch("instagramSchedule/setIsShowFormSummary", true);
      //   }
      // }, 1000);
    },
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionUpdateStatus(statusValue) {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to update status " +
          this.selectedTable.length +
          " items to " +
          statusValue +
          "?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "update_status",
              status: statusValue
            };
            this.$store
              .dispatch("instagramSchedule/actionStore", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Update",
                  text: "The data was successfully updated",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " items?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "delete"
            };
            this.$store
              .dispatch("instagramSchedule/actionStore", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    monitoringStatusLabel(status) {
      return monitoringStatusLabel(status);
    },
    monitoringStatusLabelStyle(status) {
      return monitoringStatusLabelStyle(status);
    },
    formatDateForMessage(utcDateTime, format) {
      return formatDateForMessage(utcDateTime, format);
    },
    getFirstLastDayInWeek() {
      // let days = getFirstLastDayInWeek();
      // this.serverParams.columnFilters.start_date = this.formatDateForMessage(
      //   days.firstday,
      //   "ISODate"
      // );
      // this.serverParams.columnFilters.end_date = this.formatDateForMessage(
      //   days.lastday,
      //   "ISODate"
      // );
    },
    showSearchForm() {
      this.$store.dispatch("instagramSchedule/setIsShowForm", false);
      this.$store.dispatch(
        "instagramSchedule/actFormParamStB",
        this.serverParams
      );
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("search_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("instagramSchedule/setIsShowForm", true);
        }
      }, 1000);
    },

    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },
    formatLocalDate(unixTime) {
      return formatLocalDate(unixTime);
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },

    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.linkExcel = "";
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;

      await this.$store.dispatch(
        "instagramSchedule/actFormParamStB",
        this.serverParams
      );
    },
    async searchDataMore() {
      this.linkExcel = "";

      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.serverParams = this.formParamSt;
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;

      // await this.$store.dispatch(
      //   "monitoring/actFormParamSt",
      //   this.serverParams
      // );
    },

    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);
      if (this.$route.query.scheduled) {
        this.serverParams.columnFilters.is_publish = "running";
        this.serverParams.columnFilters.is_running = "all";
        this.serverParams.more_search = true;
        this.$store.dispatch(
          "instagramSchedule/actFormParamStB",
          this.serverParams
        );
        this.searchDataMore();
        this.$router.replace({ query: null });
        return;
      }
      await this.$store
        .dispatch("instagramSchedule/listSchedule", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;

          if (this.rows.length) {
            this.rows.forEach((row, idx) => {
              let detailId = row.brand_id;
              this.$store
                .dispatch("brand/detail", detailId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  this.$refs["brand-" + row.id][0].innerHTML = resData.name;
                  // let assetsUrlArr = JSON.parse(row.assets_url);
                  // if (assetsUrlArr.length) {
                  //   assetsUrlArr.forEach((assetUrl, idxAsset) => {
                  //     this.$refs["postmedia-" + row.id][0].innerHTML =
                  //       '<a href="' +
                  //       assetUrl +
                  //       '" target="_blank"><img style="width:150px;" src="' +
                  //       assetUrl +
                  //       '" alt class="squared" /></a>';
                  //   });
                  // }
                });

              if (
                row.instagram_account_id != "" &&
                row.instagram_account_id != null
              ) {
                // this.$refs["account-" + row.id][0].innerHTML = "";
                let accountArr = JSON.parse(row.instagram_account_id);
                console.log(
                  "accountArr.length",
                  accountArr.length,
                  row.instagram_account_id
                );
                if (accountArr.length) {
                  accountArr.forEach(async (igAccountId, idxAcc) => {
                    await this.$store
                      .dispatch("instagramAccount/detail", igAccountId) // sesuai kan dengan method di API
                      .then(responseDet => {
                        var resData = responseDet.data;
                        const serverParams = {
                          columnFilters: {
                            instagram_account_id: igAccountId,
                            brand_id: row.brand_id,
                            media_type: row.media_type,
                            is_official: "1",
                            instagram_schedule_id: row.id
                          }
                        };
                        if (idxAcc > 0) {
                          // this.$refs["account-" + row.id][0].innerHTML +=
                          //   ", <a href='https://www.instagram.com/" +
                          //   resData.username +
                          //   "/' target='_blank'>" +
                          //   resData.username +
                          //   "</a>";

                          // this.$refs["account-" + row.id][0].innerHTML += `<a
                          //     href="https://www.instagram.com/${
                          //       resData.username
                          //     }/"
                          //     target="_blank"
                          //     data-toggle="tooltip"
                          //     title="${resData.username}"
                          //     ><img
                          //       alt=""
                          //       src="${require("@/assets/user.jpg")}"
                          //   /></a>`;

                          this.$store
                            .dispatch(
                              "instagramSchedule/listLogs",
                              serverParams
                            )
                            .then(response => {
                              const { data } = response;
                              const detailLog = data.data[0];

                              const tooltipComponent = this.$createElement(
                                VueCustomTooltip,
                                {
                                  props: {
                                    label: resData.username,
                                    style: "position: relative;"
                                  }
                                },
                                [
                                  this.$createElement("img", {
                                    attrs: {
                                      src: require("@/assets/user.jpg"),
                                      alt: ""
                                    }
                                  }),
                                  this.$createElement("i", {
                                    attrs: {
                                      class: `${
                                        detailLog.post_status == 2
                                          ? "la la-check"
                                          : "la la-times"
                                      } ${detailLog.post_status == 1 ||
                                        (Object.keys(detailLog).length == 0 &&
                                          "hidden")}`,
                                      style: `${
                                        detailLog.post_status == 2
                                          ? "color: #55ce63;"
                                          : "color: #e4405f;"
                                      } font-size: 16px; position: absolute; bottom: -6px; right: -10px; font-weight: bold;`
                                    }
                                  })
                                ]
                              );

                              const linkElement = this.$createElement(
                                "a",
                                {
                                  attrs: {
                                    href: `https://www.instagram.com/${resData.username}/`,
                                    target: "_blank",
                                    style: "margin-right: 6px;"
                                  }
                                },
                                [tooltipComponent]
                              );

                              const vm = new Vue({
                                render: h => h("li", [linkElement])
                              });

                              vm.$mount();
                              this.$refs["account-" + row.id][0].innerHTML +=
                                vm.$el.outerHTML;
                            });
                        } else {
                          // this.$refs["account-" + row.id][0].innerHTML =
                          //   " <a href='https://www.instagram.com/" +
                          //   resData.username +
                          //   "/' target='_blank'>" +
                          //   resData.username +
                          //   "</a>";

                          // this.$refs["account-" + row.id][0].innerHTML = `<a
                          //     href="https://www.instagram.com/${
                          //       resData.username
                          //     }/"
                          //     target="_blank"
                          //     data-toggle="tooltip"
                          //     title="${resData.username}"
                          //     ><img
                          //       alt=""
                          //       src="${require("@/assets/user.jpg")}"
                          //   /></a>`;

                          this.$store
                            .dispatch(
                              "instagramSchedule/listLogs",
                              serverParams
                            )
                            .then(response => {
                              const { data } = response;
                              const detailLog = data.data[0];

                              const tooltipComponent = this.$createElement(
                                VueCustomTooltip,
                                {
                                  props: {
                                    label: resData.username,
                                    style: "position: relative;"
                                  }
                                },
                                [
                                  this.$createElement("img", {
                                    attrs: {
                                      src: require("@/assets/user.jpg"),
                                      alt: ""
                                    }
                                  }),
                                  this.$createElement("i", {
                                    attrs: {
                                      class: `${
                                        detailLog.post_status == 2
                                          ? "la la-check"
                                          : "la la-times"
                                      } ${detailLog.post_status == 1 ||
                                        (Object.keys(detailLog).length == 0 &&
                                          "hidden")}`,
                                      style: `${
                                        detailLog.post_status == 2
                                          ? "color: #55ce63;"
                                          : "color: #e4405f;"
                                      } font-size: 16px; position: absolute; bottom: -6px; right: -10px; font-weight: bold;`
                                    }
                                  })
                                ]
                              );

                              const linkElement = this.$createElement(
                                "a",
                                {
                                  attrs: {
                                    href: `https://www.instagram.com/${resData.username}/`,
                                    target: "_blank",
                                    style: "margin-right: 6px;"
                                  }
                                },
                                [tooltipComponent]
                              );

                              const vm = new Vue({
                                render: h => h("li", [linkElement])
                              });

                              vm.$mount();
                              this.$refs["account-" + row.id][0].innerHTML +=
                                vm.$el.outerHTML;
                            });
                        }
                      });
                  });
                }
              } else {
                this.$refs["account-" + row.id][0].innerHTML =
                  "failed getting account detail";
              }
            });
          }

          this.displayCalendarFirst = false;
          this.displayCalendar = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>

<style scoped>
.event-slot-c {
  display: block;
  color: #20232a;
}
.of-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 300px;
  background-color: rgb(255, 255, 255);
  border-color: rgb(222, 225, 225);
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
}
.of-card-top {
  background-color: rgb(228, 64, 95);
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  height: 8px;
}
.of-card-header {
  padding: 8px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-radius: 8px 8px 0px 0px;
  font-size: 13px;
  line-height: 21.3333px;
  border-color: rgb(222, 225, 225);
}
.of-card-h-1 {
  padding: 8px;
  width: 100%;
  /* overflow: hidden; */
}
.of-card-h-2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.of-card-h-3 {
  margin-right: 12px;
}
.of-card-h-4 {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  overflow: hidden;
  display: flex;
  position: relative;
  flex-shrink: 0;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  color: rgb(39, 51, 51);
  background: rgb(222, 225, 225);
}
.of-card-h-5 {
  display: block;
  margin: 0px;
  width: auto;
  height: 100%;
  max-width: 100%;
}
.of-card-h-6 {
  display: flex;
}
.of-card-h-7 {
  margin: 0px;
  padding-left: 0px;
  padding-right: 0px;
  display: block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 600;
  color: rgb(54, 65, 65);
  font-size: 13px;
  line-height: 21.3333px;
}
.of-card-h-8 {
  color: rgb(54, 65, 65);
  font-weight: 400;
  font-size: 11px;
  line-height: 18.6667px;
}
.of-card-body {
  padding: 16px;
  font-size: 16px;
  line-height: 24px;
  border-color: rgb(222, 225, 225);
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
}
.of-card-body-a {
  display: flex;
  flex-direction: column;
}
.of-card-body-cap {
  margin-bottom: 12px;
  height: 63.98px;
}
.of-card-body-cap-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 3;
}
.of-card-body-cap-2 {
  font-size: 13px;
  line-height: 21.3333px;
  color: #364141;
}
.of-card-body-img {
  border: 1px solid rgb(222, 225, 225);
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  height: 299px;
  background-color: #f7f7f7;
}
.of-card-body-img-p {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  max-width: 100%;
}
.of-card-body-b {
  padding-bottom: 16px;
}
.of-card-body-c {
  display: flex;
}
.of-card-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}
.of-card-table tbody:first-child td {
  padding-top: 0px;
}
.of-card-table tbody td:first-child {
  padding-left: 0px;
  width: 100%;
  max-width: 0px;
}
.of-card-table tbody td {
  padding-bottom: 8px;
}
.of-card-table tbody tr {
  border-bottom: 1px solid rgb(222, 225, 225);
}
.of-card-td-l {
  font-size: 13px;
  line-height: 21.3333px;
  font-weight: 400;
  padding: 8px;
  text-align: left;
  color: rgb(81, 94, 95);
}
.of-card-td-r {
  font-size: 13px;
  line-height: 21.3333px;
  padding: 8px;
  text-align: right;
  color: rgb(81, 94, 95);
  font-weight: 600;
}
.box-check-all {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  border-radius: 5px;
  border: 1px solid #ced4da;
  cursor: pointer;
}
.tm {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  list-style: none;
  margin-bottom: 0;
  padding: 0;
}
.tm > li:first-child a {
  margin-left: 0;
}
.tm > li > a {
  border: 2px solid #fff;
  display: block;
  height: 30px;
  width: 30px;
}
.tm img {
  width: 100%;
  border-radius: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/instagram/instagramScheduleOfficial/list.vue